import axios from 'axios'

import {authAdapter} from '@/services/auth-adapter'

export interface WarrantyTicket {
  id: string
  dealerId: string | null
  acceptanceDate: string | null
  deviceImei: string | null
  vehicleRegNumber: string | null
  resolutionStatus: string | null
  pipelineStage: string | null
}

export interface WarrantyTicketsResponse {
  claims: WarrantyTicket[]
  total: number
  paging?: {
    next?: {
      after: string
    }
  }
}

export type WarrantyTicketStatus = 'in_progress' | 'closed'

export interface WarrantyTicketsParams {
  status?: WarrantyTicketStatus
  limit?: number
  after?: string
}

function getPortalApiBaseUrl(): string {
  // Derive Portal API base URL from PANEX_AUTHORITY
  const authority = process.env.VUE_APP_PANEX_AUTHORITY || ''
  return authority.replace(/\/oidc$/, '')
}

export class WarrantyApi {
  private readonly baseUrl: string

  constructor() {
    this.baseUrl = getPortalApiBaseUrl()
  }

  async getWarrantyTickets(dealerId: string, params?: WarrantyTicketsParams): Promise<WarrantyTicketsResponse> {
    const queryParams = new URLSearchParams()

    if (params?.status) {
      queryParams.append('status', params.status)
    }
    if (params?.limit) {
      queryParams.append('limit', params.limit.toString())
    }
    if (params?.after) {
      queryParams.append('after', params.after)
    }

    const queryString = queryParams.toString()
    const url = `${this.baseUrl}/hubspot/warranties/${dealerId}${queryString ? `?${queryString}` : ''}`

    // Get the current session token for authorization
    const session = await authAdapter.getCurrentSession()
    const idToken = session.tokens?.idToken?.toString()

    const response = await axios.get<WarrantyTicketsResponse>(url, {
      headers: idToken ? {Authorization: `Bearer ${idToken}`} : {},
    })
    return response.data
  }
}

export default new WarrantyApi()
